/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useCallback, useEffect } from 'react';
import { VscAccount } from 'react-icons/vsc';
import { Link } from 'react-router-dom';
import AuthService from '../../services/auth';
import { useAuth } from '../../hooks/auth';
import { useLoader } from '../../hooks/loader';
import Loader from '../Loader';
import Aside from './Aside';
import { GridContainer, Header, Main, MainOverview, Footer } from './styles';

interface IDashboardLayout {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<IDashboardLayout> = ({ children }) => {
  const { signOut, token } = useAuth();
  const { isActive } = useLoader();
  const services = { AuthService: new AuthService() };
  const [menuActive, setMenuActive] = useState(false);
  const [menuToggle, setMenuToggle] = useState(false);
  const [titular, setTitular] = useState<any>({});

  const handleSetMenu = useCallback(() => {
    setMenuActive(!menuActive);
  }, [menuActive]);

  const handleToggle = useCallback(() => {
    setMenuToggle(!menuToggle);
  }, [menuToggle]);

  useEffect(() => {
    const getTitular = async () => {
      try {
        if (token.access_token) {
          const response = await services.AuthService.getTitular();
          setTitular(response.data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    getTitular();
  }, []);

  return (
    <GridContainer active={menuActive} toggle={menuToggle}>
      {isActive && <Loader />}
      <Header>
        <button type="button" className="menu-icon" onClick={handleSetMenu}>
          <strong> &#9776;</strong>
        </button>
        <div className="header-wrap">
          <div className="profile">
            <div className="profile-data">
              <div>
                <h3>
                  <Link to="/meu-perfil">
                    {!!titular.DadosDoTitular && (
                      <>{`${titular.DadosDoTitular.RazaoSocial}`}</>
                    )}
                  </Link>
                </h3>
              </div>
              <button type="button" onClick={signOut} className="sair">
                Sair
              </button>
            </div>
            <Link to="/meu-perfil">
              <VscAccount
                style={{
                  color: 'var(--white)',
                }}
                size={28}
              />
            </Link>
          </div>
        </div>
      </Header>
      <Aside
        activeMenu={handleSetMenu}
        activeToggle={handleToggle}
        toggled={menuToggle}
        actived={menuActive}
      />
      <Main>
        <MainOverview>{children}</MainOverview>
      </Main>
      <Footer />
    </GridContainer>
  );
};

export default DashboardLayout;
